import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Aishu.css';

function QuoteModal({ date, quote, onClose }) {
  const [isFlipped, setIsFlipped] = useState(true); // Changed to true
  
  // Close modal on escape key press
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
  
  return (
    <div className="quote-modal-overlay" onClick={onClose}>
      <div className="quote-modal-content" onClick={(e) => e.stopPropagation()}>
        <div 
          className={`quote-card ${isFlipped ? 'is-flipped' : ''}`} 
          onClick={() => setIsFlipped(!isFlipped)}
        >
          <div className="card-face card-front">
            <div className="card-date">{date}</div>
          </div>
          <div className="card-face card-back">
            <p className="quote-text">{quote}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AishuPage({ isAuthenticated, onAuthenticate }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === 'tinban23') {
      onAuthenticate(true);
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };

  
  const quotes = [
    "You are my sun, my moon, and all my stars. - E.E. Cummings", "If I know what love is, it is because of you. - Hermann Hesse", "My heart is and always will be yours. - Jane Austen", "I love you not only for what you are, but for what I am when I am with you.", "If I had a flower for every time I thought of you, I could walk through my garden forever.", "I would rather spend one lifetime with you, than face all the ages of this world alone.", "To love you and be loved by you is to feel the sun from both sides. - David Viscott", "I saw that you were perfect, and so I loved you. Then I saw that you were not perfect and I loved you even more. - Angelita Lim", "In all the world, there is no heart for me like yours. In all the world, there is no love for you like mine. - Maya Angelou", "You are the finest, loveliest, tenderest, and most beautiful person I have ever known—and even that is an understatement. - F. Scott Fitzgerald", "I knew the second I met you that there was something about you I needed. Turns out it wasn't something about you at all. It was just you.", "Whatever our souls are made of, his and mine are the same. - Emily Brontë", "You are my today and all of my tomorrows.", "My love for you is a journey, starting at forever and ending at never.", "Every day I discover that I love you even more, and in this infinite universe I will love you till the end.", "You're the part of me I'll always need.", "I love you more than I have ever found a way to say to you. - Ben Folds", "For it was not into my ear you whispered, but into my heart. It was not my lips you kissed, but my soul. - Judy Garland", "I love you, and that’s the beginning and end of everything. - F. Scott Fitzgerald", "You are the answer to every prayer I've offered.", "A hundred hearts would be too few to carry all my love for you.", "Being with you and not being with you is the only way I have to measure time.", "I find the most beautiful moments of life aren't just with you but because of you.", "Sometimes your nearness takes my breath away; and all the things I want to say can find no voice. Then, in silence, I can only hope my eyes will speak my heart.", "When I look into your eyes, I know I've found the mirror of my soul.", "To love is nothing. To be loved is something. But to love and be loved by you, that’s everything.", "I still haven’t figured out how to sit across from you, and not be madly in love with everything you do.", "To the world you may be one person, but to one person you are the world.", "My heart beats faster as you take my hand, my love grows stronger as you touch my soul.", "I fell in love with you because of the million things you never knew you were doing.", "You are whatever a moon has always meant and whatever a sun will always sing.", "In a world full of temporary things, you are a perpetual feeling", "You are the last thought in my mind before I drift off to sleep and the first thought when I wake up each morning."
  ];

  const getDates = () => {
    const dates = [];
    const startDate = new Date('2025-12-13T00:00:00');
    const endDate = new Date('2026-01-14T00:00:00');
    let currentDate = startDate;
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates.map(date => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }));
  };

  const dates = getDates();

  if (!isAuthenticated) {
    return (
      <div className="aishu-page">
        <div className="animated-bg" />
        <div className="aishu-password-container">
          <h2>Password Required</h2>
          <form onSubmit={handleSubmit} className="password-form">
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" className="password-input" autoFocus />
            {error && <p className="password-error">Incorrect password. Try again.</p>}
            <button type="submit" className="password-submit">Enter</button>
          </form>
        </div>
      </div>
    );
  }

  const activeCard = activeIndex !== null ? { date: dates[activeIndex], quote: quotes[activeIndex % quotes.length] } : null;

  return (
    <div className="aishu-page">
      <div className="animated-bg" />
      <div className="aishu-content">
        <Link to="/" className="back-button">← Back to Home</Link>
        <h1 className="aishu-title">For Aishu</h1>
        <p className="aishu-subtitle">A card for each day until I see you again.</p>
        <div className="quote-grid">
          {dates.map((date, index) => (
            <div key={index} className="quote-card-thumbnail" onClick={() => setActiveIndex(index)}>
              <div className="card-date">{date}</div>
            </div>
          ))}
        </div>
      </div>
      {activeCard && <QuoteModal date={activeCard.date} quote={activeCard.quote} onClose={() => setActiveIndex(null)} />}
    </div>
  );
}
